import type { IconSvgObject } from './types';

const ArrowRightBigIcon: IconSvgObject = [
  ["path", { d: "M20.1336 12.8402L13.7066 18.8081C13.5738 18.9315 13.3993 19 13.218 19C12.8215 19 12.5 18.6785 12.5 18.282V15H4.5C3.94772 15 3.5 14.5523 3.5 14V10C3.5 9.44772 3.94772 9 4.5 9L12.5 9V5.71803C12.5 5.32147 12.8215 5 13.218 5C13.3993 5 13.5738 5.06854 13.7066 5.19186L20.1336 11.1598C20.3672 11.3767 20.5 11.6812 20.5 12C20.5 12.3188 20.3672 12.6233 20.1336 12.8402Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ArrowRightBigIcon;
